module.exports = __webpack_public_path__ + "img/guigeliao5.3638adfc.jpg";